// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"225e026b","624":"21ef022a","726":"2c1ee20e"}[chunkId] + ".chunk.js";
};